import React from 'react'
import { connect } from 'react-redux'
import { Routes, Route } from 'react-router-dom'
import Rooms from './rooms/Root'
import Room from './room/Root'
import Loading from './components/Loading'

const Routing = ({ browser: { ws }, rooms }) => {
  if (ws && rooms.length > 0) {
    return (
      <Routes>
        <Route path="/" element={<Rooms />} />
        <Route path="/room/:roomNo" element={<Room />} />
      </Routes>
    )
  } else {
    return (
      <Routes>
        <Route path="/" element={<Loading />} />
        <Route path="/room/:roomNo" element={<Loading />} />
      </Routes>
    )
  }
}

export default connect(
  state => ({
    browser: state.browser,
    rooms: state.rooms
  })
)(Routing)
